import { useCallback } from 'react'
import { useQuery } from '@tanstack/react-query'
import { settingsService } from '@/lib/services/settings'
import { visibleModuleStops, SetupModuleKey } from '@/lib/setupModules'

// Onboarding tour pages for a module, minus pages this store has switched off.
// Reads the shared ['settings'] cache entry.
export function useModuleStops() {
  const { data: settings } = useQuery({
    queryKey: ['settings'],
    queryFn: settingsService.getSettings,
    staleTime: 5 * 60 * 1000,
  })
  return useCallback((key: SetupModuleKey) => visibleModuleStops(key, settings), [settings])
}
